<div class="row no-gutters">
  <div class="col-xxl-10 offset-xxl-1 mt-4" style="border-top: 2px solid #D1D7DC">
    <h1 class="my-4">Investment Pool Details and Performance</h1>

    <div class="row">
      <div class="col-lg-6 pb-4">

        <div class="h5-text">{{assetAllocationLegend.title}}</div>
        <p class="legend-description">
          {{assetAllocationLegend.description}}
        </p>

        @if (isChartDataAvailable) {
          <div class="summary-graph">
            <canvas baseChart
              class="asset-allocation"
              height="390" width="390"
              style="max-width: 390px; max-height: 390px; margin: 0 auto;"
              [datasets]="doughnutChartDatasets"
              [labels]="doughnutChartLabels"
              [legend]=false
            type="doughnut" [options]="doughnutChartOptions"></canvas>
          </div>
        }
      </div>
      @if (assetAllocationLegend) {
        <div class="col-lg-6">
          <div class="row">
            <div class="col-sm-6">
              @for (item of assetAllocationLegend.data1; track item) {
                <div class="data-block">
                  <span class="marker" [ngStyle]="{'background-color': item.color}"></span>
                  <a class="allocation-title">{{item.title}}</a><br>
                  @for (dt of item.data; track dt) {
                    <div class="allocation-item">
                      @if (dt.link) {
                        <a href="{{dt.link}}" target="_blank" class="download-link">{{dt.title}}</a>
                      }
                      @if (!dt.link) {
                        <span>{{dt.title}}</span>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            <div class="col-sm-6">
              @for (item of assetAllocationLegend.data2; track item) {
                <div class="data-block">
                  <span class="marker" [ngStyle]="{'background-color': item.color}"></span>
                  <a class="allocation-title">{{item.title}}</a><br>
                  @for (dt of item.data; track dt) {
                    <div class="allocation-item">
                      @if (dt.link) {
                        <a href="{{dt.link}}" target="_blank" class="download-link">{{dt.title}}</a>
                      }
                      @if (!dt.link) {
                        <span>{{dt.title}}</span>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>


    @if (pagedFinancialStatements) {
      <div style="border-top: 2px solid #D1D7DC" class="mt-4">
        <h1 class="collapser collapsed my-4" data-toggle="collapse" href="#AnnualReportingTable" aria-controls="AnnualReportingTable" style="cursor:pointer">Annual Reporting</h1>
        <div id="AnnualReportingTable" class="collapse">
          <table width="100%" class="NWMtable table-hover">
            <thead>
              <tr>
                <td width="40%">Investment Name</td>
                <td width="30%">Document Description</td>
                <td width="30%">Date</td>
              </tr>
            </thead>
            <tbody>
              @for (res of pagedFinancialStatements.Items; track res) {
                <tr (click)="handleDownload(res.Link)">
                  <td>{{res.Title}}</td>
                  <td>{{res.Description }}</td>
                  <td>{{res.Date | date:'MMM yyyy' }}</td>
                </tr>
              }
            </tbody>
          </table>
          @if (totalPages! > 1) {
            <ngb-pagination [collectionSize]="pagedFinancialStatements.TotalItems"
              [(page)]="page" [maxSize]="5" (pageChange)="loadPage()" [pageSize]="pageSize"
              class="mt-2 float-right pagination"
              [boundaryLinks]="true"
              data-scrollTo="#AnnualReportingTable" />
            }
          </div>
        </div>
      }
    </div>
  </div>
